module.exports = __webpack_public_path__ + "img/日常安全监测运营.4ea1bf0f.png";